import { useEffect, useState } from "react";
import { Navigate, useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function WhCode() {
  const { code } = useParams();
  const [target, setTarget] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/wh/items/by-code/${encodeURIComponent(code)}`).then(({ data }) => setTarget(data.id)).catch(() => setErr(true));
  }, [code]);
  if (target) return <Navigate to={`/magazzino/articoli/${target}`} replace />;
  if (err) return <div className="space-y-3" data-testid="wh-code-not-found"><p>Nessun articolo con codice <b className="font-mono">{code}</b>.</p><Link to="/magazzino" className="underline">Torna al magazzino</Link></div>;
  return <p className="text-[var(--muted)]">Apertura scheda...</p>;
}
